// extracted by mini-css-extract-plugin
module.exports = {"ellipsis":"SpacesPage__ellipsis__2TxQe","flex-child-ellipsis":"SpacesPage__flex-child-ellipsis__zWQoP","multiplayer-cursor":"SpacesPage__multiplayer-cursor__Ui2gb"};